import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const SbiLoanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            question: "What’s the maximum loan amount I can take from SBI for a car?",
            answer: "SBI typically offers up to 90% of the car’s on-road price. The maximum loan amount varies based on income and credit profile."
          },
          {
            question: "Can I apply for a car loan jointly?",
            answer: "Yes, you can apply with a co-applicant, such as a spouse or parent, to increase eligibility."
          },
          {
            question: "How is the SBI interest rate determined?",
            answer: "SBI uses a combination of credit score, repayment history, and income level to determine your applicable interest rate."
          },
          {
            question: "Is the EMI fixed throughout the tenure?",
            answer: "Yes, for fixed-rate loans. However, if you opt for floating rates, EMIs may vary depending on the benchmark rate."
          },
          {
            question: "Does the EMI calculator include processing fees?",
            answer: "No, it only calculates EMI based on principal, interest, and tenure. Fees are extra and vary."
          },
          {
            question: "Can I reduce my EMI after taking the loan?",
            answer: "You can reduce your EMI by prepaying part of the loan or refinancing at a lower rate."
          },
          {
            question: "What is the minimum car loan tenure?",
            answer: "The minimum tenure is typically 12 months. The maximum can go up to 7 years."
          },
          {
            question: "Is there a penalty for prepayment?",
            answer: "SBI generally does not charge prepayment fees on floating-rate loans but may charge a small fee for fixed-rate loans."
          },
          {
            question: "How do I know if I can afford the EMI?",
            answer: "Ensure your total EMIs (including other loans) are not more than 40–50% of your monthly income."
          },
          {
            question: "Can I get a car loan without income proof?",
            answer: "Generally, income proof is mandatory unless you're a pre-approved customer or applying under a special scheme."
          },
          {
            question: "Does EMI change if interest rate changes?",
            answer: "Only in floating-rate loans. Fixed-rate loans maintain constant EMI."
          },
          {
            question: "Can I check EMI for used car loans?",
            answer: "Yes. Just enter the applicable interest rate (usually higher than new cars) and adjust the tenure."
          },
          {
            question: "What documents are required?",
            answer: "KYC documents, income proof, bank statements, car quotation, and photographs."
          },
          {
            question: "What is the EMI for a ₹10 lakh loan over 7 years?",
            answer: "At 8.75%, your EMI will be approx ₹15,900. Use our calculator for an exact figure."
          },
          {
            question: "Can I pay more than one EMI in advance?",
            answer: "Yes. Advance EMI or part-prepayments are allowed and help reduce your outstanding balance and interest burden."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
          <title>SBI Car Loan EMI Calculator – Estimate Your Monthly Payments Easily</title>
        <meta  name='description' content='Use the SBI Car Loan EMI Calculator to calculate your monthly repayments. Get accurate EMI estimates and plan your auto loan efficiently.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/sbi-car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">SBI Car Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">SBI Car Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your SBI Car Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying a car is one of the most exciting milestones in life. Whether you’re purchasing your first vehicle, upgrading your family car, or investing in a premium model, planning your finances well is key to making a confident and stress-free decision. One of the most critical parts of this planning is understanding how much you’ll be repaying every month – and that’s where our SBI Car Loan EMI Calculator comes in.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            At TheFinMaster, we understand the modern Indian consumer – ambitious, practical, and financially conscious. Our calculator is designed to provide a seamless and comprehensive understanding of your loan commitments, helping you structure your EMI to match your cash flow, lifestyle, and long-term goals.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Before you apply for a car loan, it's essential to understand what an EMI is and how it impacts your finances.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Car Loan EMI (Equated Monthly Instalment) is the fixed amount you pay every month to repay the car loan you have taken. This amount includes both the principal (the original loan amount) and the interest charged by the bank. EMI payments continue throughout the loan tenure until the entire amount is fully repaid.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI structure is designed in such a way that, in the initial stages, a higher portion of the EMI goes toward the interest. Over time, the interest component reduces while the principal repayment portion increases. This concept is based on the reducing balance method commonly used by most banks in India, including SBI.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Let’s consider an example:<br />
              If you take a car loan of ₹6,00,000 for 5 years at an interest rate of 8.75% per annum, your EMI will be around ₹12,418. Over the course of 60 months, you'll repay a total of ₹7,45,080 – which includes ₹6,00,000 as principal and ₹1,45,080 as interest.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding your EMI helps you manage your budget effectively and ensures you're not overextending your monthly liabilities.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is SBI Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The SBI Car Loan EMI Calculator is a free, intelligent digital tool developed by TheFinMaster to help users instantly calculate their car loan EMIs when borrowing from the State Bank of India (SBI), one of the most trusted financial institutions in the country.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator is not just a mathematical engine. It's a financial planning assistant. By entering a few basic details like your loan amount, interest rate, and tenure, you get a clear breakdown of:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Monthly EMI payments</li>
              <li>Total interest payable</li>
              <li>Total repayment amount</li>
              <li>Optional amortisation schedule</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This allows you to take control of your decisions even before applying for a car loan.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Key Highlights:</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Custom-built for SBI’s car loan schemes</li>
              <li>Real-time, accurate results</li>
              <li>No registration or login needed</li>
              <li>Accessible on mobile, desktop, or tablet</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Whether you’re buying a new hatchback worth ₹5 lakh or a premium SUV priced at ₹20 lakh, this calculator ensures that your finances are well-aligned with your aspirations.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s SBI Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Here’s why thousands of users trust TheFinMaster’s SBI Car Loan EMI Calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong> Instant Results</strong><br />
                Manually calculating EMIs can be complicated and time-consuming. Our calculator delivers results in seconds with just three inputs.
              </li>
              <li><strong> Improved Loan Planning</strong><br />
                Before applying for a loan, use our tool to test different combinations of loan amount, tenure, and interest rate. This helps you identify a repayment plan that suits your income and future plans.
              </li>
              <li><strong> Comparison Across Options</strong><br />
                Thinking of comparing a 3-year loan with a 5-year one? Or debating between a ₹7 lakh or ₹8 lakh loan? Try different values and instantly compare outcomes.
              </li>
              <li><strong> Saves You from Overborrowing</strong><br />
                Sometimes we fall in love with cars that are slightly over budget. This calculator helps ground those decisions in real numbers, showing if that dream car will lead to stress or ease.
              </li>
              <li><strong> No Personal Data Required</strong><br />
                Unlike other platforms, we don’t ask for your phone number or email to use the calculator. No spam, just smart calculations.
              </li>
              <li><strong> Better Negotiations with Dealers</strong><br />
                Walk into the dealership with clarity and numbers. Knowing your EMI limits makes it easier to reject expensive add-ons and upsells.
              </li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the SBI Car Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The SBI Car Loan EMI Calculator uses the standard EMI formula used by banks and NBFCs:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P × R × (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal loan amount</li>
              <li>R is the monthly interest rate (annual interest rate ÷ 12 ÷ 100)</li>
              <li>N is the loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              You borrow ₹7,00,000 at 8.75% interest for a tenure of 5 years (60 months):<br />
              P = ₹7,00,000<br />
              R = 0.00729 (8.75% annual ÷ 12 ÷ 100)<br />
              N = 60 months<br />
              Plugging into the formula, your EMI is approximately ₹14,487
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator also shows you:<br />
              Total Interest Payable = ₹1,69,220<br />
              Total Payment = ₹8,69,220
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              You can try any number of combinations until you find a plan that fits your budget perfectly.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a table that shows the breakdown of each EMI into:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>The interest component</li>
              <li>The principal repayment component</li>
              <li>The outstanding loan balance after each month</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This table helps borrowers understand how their loan is being repaid and how much interest they’re paying at each stage. It’s especially useful if you’re considering prepaying your loan or want to track how quickly your debt is reducing.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>📅 12-Month Amortisation Schedule for ₹6,00,000 at 8.75% for 5 Years</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,375</td>
                    <td className="border px-4 py-2">8,043</td>
                    <td className="border px-4 py-2">5,91,957</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,319</td>
                    <td className="border px-4 py-2">8,099</td>
                    <td className="border px-4 py-2">5,83,858</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,263</td>
                    <td className="border px-4 py-2">8,155</td>
                    <td className="border px-4 py-2">5,75,703</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,207</td>
                    <td className="border px-4 py-2">8,211</td>
                    <td className="border px-4 py-2">5,67,492</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,150</td>
                    <td className="border px-4 py-2">8,268</td>
                    <td className="border px-4 py-2">5,59,224</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,093</td>
                    <td className="border px-4 py-2">8,325</td>
                    <td className="border px-4 py-2">5,50,899</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">4,035</td>
                    <td className="border px-4 py-2">8,383</td>
                    <td className="border px-4 py-2">5,42,516</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">3,977</td>
                    <td className="border px-4 py-2">8,441</td>
                    <td className="border px-4 py-2">5,34,075</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">3,918</td>
                    <td className="border px-4 py-2">8,500</td>
                    <td className="border px-4 py-2">5,25,575</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">3,859</td>
                    <td className="border px-4 py-2">8,559</td>
                    <td className="border px-4 py-2">5,17,016</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">3,800</td>
                    <td className="border px-4 py-2">8,618</td>
                    <td className="border px-4 py-2">5,08,398</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">12,418</td>
                    <td className="border px-4 py-2">3,740</td>
                    <td className="border px-4 py-2">8,678</td>
                    <td className="border px-4 py-2">4,99,720</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
                  <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Principal (₹)</th>
          <th className="border px-4 py-2 text-left">Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "12,418", "4,375", "8,043", "5,91,957"],
          ["2", "12,418", "4,319", "8,099", "5,83,858"],
          ["3", "12,418", "4,263", "8,155", "5,75,703"],
          ["4", "12,418", "4,207", "8,211", "5,67,492"],
          ["5", "12,418", "4,150", "8,268", "5,59,224"],
          ["6", "12,418", "4,093", "8,325", "5,50,899"],
          ["7", "12,418", "4,035", "8,383", "5,42,516"],
          ["8", "12,418", "3,977", "8,441", "5,34,075"],
          ["9", "12,418", "3,918", "8,500", "5,25,575"],
          ["10", "12,418", "3,859", "8,559", "5,17,016"],
          ["11", "12,418", "3,800", "8,618", "5,08,398"],
          ["12", "12,418", "3,740", "8,678", "4,99,720"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
          ["1", "12,418", "4,375", "8,043", "5,91,957"],
          ["2", "12,418", "4,319", "8,099", "5,83,858"],
          ["3", "12,418", "4,263", "8,155", "5,75,703"],
          ["4", "12,418", "4,207", "8,211", "5,67,492"],
          ["5", "12,418", "4,150", "8,268", "5,59,224"],
          ["6", "12,418", "4,093", "8,325", "5,50,899"],
          ["7", "12,418", "4,035", "8,383", "5,42,516"],
          ["8", "12,418", "3,977", "8,441", "5,34,075"],
          ["9", "12,418", "3,918", "8,500", "5,25,575"],
          ["10", "12,418", "3,859", "8,559", "5,17,016"],
          ["11", "12,418", "3,800", "8,618", "5,08,398"],
          ["12", "12,418", "3,740", "8,678", "4,99,720"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Balance (₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Over time, you’ll see your interest burden reduce while your principal repayment increases. Understanding this helps in planning prepayments smartly.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several variables influence how much EMI you pay every month. Understanding these factors gives you control over structuring a financially sound loan.
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong> Loan Amount</strong><br />
                Higher principal = higher EMI. If you’re trying to reduce your EMI, consider making a higher down payment.
              </li>
              <li><strong> Interest Rate</strong><br />
                SBI offers car loan interest rates typically ranging from 8.75% to 9.50% depending on your credit score and the loan scheme. Even a 0.25% change can affect your total interest substantially.
              </li>
              <li><strong> Tenure</strong><br />
                Shorter tenures increase EMI but reduce interest costs. Longer tenures do the opposite. Always balance monthly affordability with long-term cost.
              </li>
              <li><strong> Credit Score</strong><br />
                A credit score of 750+ can help you qualify for lower interest rates. A low score might result in higher EMIs.
              </li>
              <li><strong> Vehicle Type</strong><br />
                Loans for new cars typically come with better terms compared to used cars. SBI also offers concessional rates on electric vehicles.
              </li>
              <li><strong> Income Stability</strong><br />
                Banks assess your monthly income and liabilities to decide your EMI-to-income ratio. Your loan eligibility and EMI depend on this ratio.
              </li>
            </ul>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default SbiLoanEmiCalculator ;
